import { createBrowserRouter } from "react-router-dom";
import React from "react";
import { SignIn } from "modules/auth";
import { MapRoutes } from "components/router/map-routes";
import Dashboard from "@/layouts";
import ProjectPortfolio from "../modules/portfolio/index";
import { Navigate, Outlet } from "react-router-dom";
import CaseStudiesIndex from "@/modules/casestudies/index";
import ProjectDetails from "@/modules/casestudies/casestudy/dashboard";
import { getCaseStudyDetails } from "@/modules/casestudies/utils/api";
import CasestudyLayout from "@/modules/casestudies/casestudy/crud/layout";
import UpdateCaseStudy from "@/modules/casestudies/casestudy/crud/update";
import Outcomes from "@/modules/casestudies/casestudy/crud/outcomes";
import Deliverables from "@/modules/casestudies/casestudy/crud/deliverables";
import Testimonials from "@/modules/casestudies/casestudy/crud/testimonials";
import TechStack from "@/modules/casestudies/casestudy/crud/tech-stack";
import ToolsCasestudy from "@/modules/casestudies/casestudy/crud/tools";
import VideoForm from "@/modules/casestudies/casestudy/crud/video";
import BasicDetailsForm from "@/modules/casestudies/casestudy/crud/basic-details/form";
import ClientContextForm from "@/modules/casestudies/casestudy/crud/client-context/form";
import ResultForm from "@/modules/casestudies/casestudy/crud/results/form";
import ScreenshotsForm from "@/modules/casestudies/casestudy/crud/screenshots/form";
import { PermissionGate } from "permissions/index";
import Tools from "@/modules/master-data/tools";
import TechStacks from "@/modules/master-data/tech-stack";
import CreateTechStack from "@/modules/master-data/tech-stack/crud/create";
import UpdateTechStack from "@/modules/master-data/tech-stack/crud/update";
import CreateTool from "@/modules/master-data/tools/crud/create";
import UpdateTool from "@/modules/master-data/tools/crud/update";

const routeConfig = [
  {
    path: "/login",
    element: <SignIn />,
    public: true,
    handle: {
      crumb: () => "Login",
    },
  },
  {
    path: "/",
    element: <Dashboard />,
    handle: {
      crumb: () => "dashboard",
    },
    children: [
      {
        index: true,
        element: <Navigate to="case-studies" replace />,
      },
      {
        path: "case-studies",
        element: <Outlet />,
        handle: { crumb: () => "Case Studies" },
        children: [
          {
            index: true,
            element: <CaseStudiesIndex />,
          },
          {
            path: ":casestudyId",
            element: <Outlet />,
            children: [
              {
                index: true,
                element: <ProjectDetails />,
                handle: {
                  crumb: (data) => {
                    if (data?.isLoading?.casestudy) return "Loading...";
                    return data?.casestudy || "Project Details";
                  },
                },
              },
              {
                path: "edit",
                element: (
                  <PermissionGate
                    collection="case_studies"
                    rule="update:PC,JC"
                    fallback={<Navigate to="/case-studies" replace />}
                  >
                    <UpdateCaseStudy />
                  </PermissionGate>
                ),
                children: [
                  {
                    index: true,
                    element: <Navigate to="basic-details" replace />,
                  },
                  {
                    path: "basic-details",
                    element: <BasicDetailsForm />,
                  },
                  {
                    path: "client",
                    element: <ClientContextForm />,
                  },
                  {
                    path: "results",
                    element: <ResultForm />,
                  },
                  {
                    path: "outcomes",
                    element: <Outlet />,
                    children: [
                      { index: true, element: <Outcomes /> },
                      {
                        path: ":itemId",
                        element: <Outcomes />,
                      },
                    ],
                  },
                  {
                    path: "tech-stack",
                    element: <TechStack />,
                  },
                  {
                    path: "tools",
                    element: <ToolsCasestudy />,
                  },
                  {
                    path: "deliverables",
                    element: <Deliverables />,
                  },
                  {
                    path: "testimonials",
                    element: <Testimonials />,
                  },
                  {
                    path: "screenshots",
                    element: <ScreenshotsForm />,
                  },
                  {
                    path: "video",
                    element: <VideoForm />,
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        path: "master-data",
        element: <Outlet />,
        handle: { crumb: () => "Master Data" },
        children: [
          {
            index: true,
            element: <Navigate to="tech-stack" replace />,
          },
          {
            path: "tech-stack",
            element: <Outlet />,
            handle: { crumb: () => "Tech Stack" },
            children: [
              {
                index: true,
                element: <TechStacks />,
              },
              {
                path: "+",
                element: <CreateTechStack />,
              },
              {
                path: ":techStackId",
                element: <UpdateTechStack />,
              },
            ],
          },
          {
            path: "tools",
            element: <Outlet />,
            handle: { crumb: () => "Tools" },
            children: [
              {
                index: true,
                element: <Tools />,
              },
              {
                path: "+",
                element: <CreateTool />,
              },
              {
                path: ":toolId",
                element: <UpdateTool />,
              },
            ],
          },
        ],
      },
      {
        path: "explore",
        element: <ProjectPortfolio />,
        handle: { crumb: () => "Explore" },
        children: [
          {
            path: ":chatId",
            element: <ProjectPortfolio />,
          },
        ],
      },
    ],
  },
];

const routes = createBrowserRouter(MapRoutes(routeConfig));

export default routes;
